import Marquee from "react-fast-marquee";
import { Asterisk } from "lucide-react";

const items = [
  "30 ans UNESCO",
  "750 km",
  "6 sites d'exposition",
  "Océan · Méditerranée",
  "Canal des 2 Mers",
  "Riquet · 1666",
  "Effacer les murs",
  "Le Fil du Midi",
];

export default function EditorialMarquee({ inverted = false }) {
  return (
    <div
      className={`py-10 md:py-14 border-y ${inverted ? "bg-fg text-bg border-bg/20" : "border-fg/25 bg-bg"}`}
      data-testid="editorial-marquee"
    >
      <Marquee gradient={false} speed={38} pauseOnHover>
        {items.concat(items).map((t, i) => (
          <span key={i} className="flex items-center gap-8 pr-12">
            <span className={`font-serif italic text-4xl md:text-6xl lg:text-7xl leading-none tracking-tight ${inverted ? "text-bg" : "text-fg"}`} style={{ fontWeight: 500 }}>{t}</span>
            <Asterisk size={30} className="text-cinabre shrink-0" strokeWidth={1.2} />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
